export const environment = {
  ns:            'DEVELOPMENT',
  production:    false,
  cookieKey:     'epl-development',
  cookieBaseUrl: 'epl-dev.blackforestbytes.de',
  apiBaseUrl:    '/api/v1/',
};
